(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gtc-recipe-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gtc-recipe-gallery')) {
  customElements.define('gtc-recipe-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => {
        const card = event.target.closest('[data-recipe-id]');
        if (!card || !this.contains(card)) return;
        if (event.target.closest('[data-recipe-product]')) this.report('product_click', card);
        const button = event.target.closest('.gtc-recipes__play');
        if (!button) return;
        const template = card.querySelector('[data-video-template]');
        if (!template) return;
        let video = card.querySelector('video');
        if (!video) {
          template.before(template.content.cloneNode(true));
          video = card.querySelector('video');
          if (!video) return;
          video.setAttribute('aria-label', card.querySelector('h3').textContent);
          video.addEventListener('error', () => {
            video.pause();
            video.remove();
            button.removeAttribute('aria-busy');
            button.hidden = false;
            card.querySelector('.gtc-recipes__error').hidden = false;
            if (this.isConnected) button.focus({preventScroll:true});
          }, {capture:true, signal});
          video.addEventListener('playing', () => {
            button.removeAttribute('aria-busy');
            button.hidden = true;
            video.focus({preventScroll:true});
          }, {signal});
        }
        card.querySelector('.gtc-recipes__error').hidden = true;
        button.setAttribute('aria-busy', 'true');
        video.preload = 'auto';
        if (video.readyState === 0) video.load();
        const play = video.play();
        if (play) play.catch(() => {
          if (!video.isConnected) return;
          button.removeAttribute('aria-busy');
          button.hidden = false;
          card.querySelector('.gtc-recipes__error').hidden = false;
        });
      }, {signal});
      this.addEventListener('play', (event) => {
        const video = event.target;
        if (!(video instanceof HTMLVideoElement)) return;
        document.querySelectorAll('gtc-recipe-gallery video').forEach(other => {
          if (other !== video) other.pause();
        });
        const card = video.closest('[data-recipe-id]');
        if (!video.dataset.gtcPlayed) {
          video.dataset.gtcPlayed = 'true';
          this.report('play', card);
        }
      }, {capture:true, signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const card = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              if (!card.dataset.gtcExposed) {
                card.dataset.gtcExposed = 'true';
                this.report('view', card);
              }
            } else {
              card.querySelector('video')?.pause();
            }
          });
        }, {threshold:[0,0.5]});
        this.querySelectorAll('[data-recipe-id]').forEach(card => this.observer.observe(card));
      }
    }
    report(action, card) {
      if (!card) return;
      this.dispatchEvent(new CustomEvent('gtc:recipe', {
        bubbles:true,
        detail:{action,sectionId:this.dataset.sectionId,recipeId:card.dataset.recipeId}
      }));
    }
    pauseAll() {
      this.querySelectorAll('video').forEach(video => video.pause());
    }
    disconnectedCallback() {
      this.pauseAll();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.observer = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    
    this.totalSlides = this.querySelectorAll('.swiper-slide').length
    this.slider = null

    // Swiper 초기화
    const initSwiper = () => {
      const swiperEl = this.querySelector('.swiper')
      if (!swiperEl || !window.Swiper) return

      this.slider = new window.Swiper(swiperEl, this.swiperOptions())

      this.slider.on('slideChange', () => {
        swiperEl.classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      this.slider.on('slideChangeTransitionEnd', () => {
        swiperEl.classList.remove('swiper-is-changing')
      })
      
      // 슬라이드 개수에 따른 가운데 정렬 처리
      this.handleCenterAlignment()
      
      // 리사이즈 시 재계산
      window.addEventListener('resize', () => {
        this.handleCenterAlignment()
      })
    }

    if (document.readyState === 'complete') {
      setTimeout(initSwiper, 100)
    } else {
      window.addEventListener('load', () => setTimeout(initSwiper, 100))
    }

    // 사운드 토글 버튼 클릭
    this.querySelectorAll('.lumin-shoppable-videos-btn-sound').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation()
        const card = btn.closest('.lumin-shoppable-videos-card')
        const video = card?.querySelector('video')
        if (video) {
          this.toggleMute(video, card)
        }
      })
    })

    // 재생 버튼 클릭
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation()
        const card = btn.closest('.lumin-shoppable-videos-card')
        const facade = card?.querySelector('.video-facade')
        
        // Facade가 있고 아직 로드 안됐으면 비디오 로드
        if (facade && !facade.classList.contains('loaded')) {
          this.loadAndPlayVideo(facade)
        } else {
          // 이미 로드된 비디오면 재생/정지 토글
          const video = card?.querySelector('video')
          if (video) {
            this.togglePlayPause(video, card)
          }
        }
      })
    })

    // 비디오 클릭 → 재생/정지 토글
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', (e) => {
        e.stopPropagation()
        const card = video.closest('.lumin-shoppable-videos-card')
        if (card) {
          this.togglePlayPause(video, card)
        }
      })
    })

    // Video Facade 클릭 시 비디오 로드
    this.querySelectorAll('.video-facade').forEach(facade => {
      facade.addEventListener('click', (e) => {
        e.stopPropagation()
        const card = facade.closest('.lumin-shoppable-videos-card')
        if (card && !facade.classList.contains('loaded')) {
          this.loadAndPlayVideo(facade)
        }
      })
    })

    // viewport 진입/이탈 시 자동 재생/정지
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const card = entry.target.closest('.lumin-shoppable-videos-card')
          const autoplayEnabled = card?.dataset.autoplay === 'true'
          
          if (entry.isIntersecting && autoplayEnabled) {
            // 자동재생 ON: Facade 찾아서 비디오 로드
            const facade = card.querySelector('.video-facade')
            if (facade && !facade.classList.contains('loaded')) {
              this.loadAndPlayVideo(facade)
            } else {
              // 이미 로드된 비디오면 재생
              const video = card.querySelector('video')
              if (video) {
                video.play().then(() => {
                  card.setAttribute('data-is-paused', 'false')
                }).catch(() => {
                  card.setAttribute('data-is-paused', 'true')
                })
              }
            }
          } else if (!entry.isIntersecting) {
            // viewport 벗어나면 정지
            const video = card?.querySelector('video')
            if (video) {
              video.pause()
              video.muted = true
              if (card) {
                card.setAttribute('data-is-muted', 'true')
                card.setAttribute('data-is-paused', 'true')
              }
            }
          }
        })
      }, { rootMargin: '0px', threshold: 0.5 })
      
      // Facade를 observe (비디오 대신)
      this.querySelectorAll('.video-facade').forEach((el) => {
        videoObserver.observe(el)
      })
    }

    // 초기 상태 설정
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(card => {
      // 🎵 기본값: 음소거 해제 (비디오 template에서 muted: false)
      card.setAttribute('data-is-muted', 'false')
      // 자동재생 OFF인 경우 초기 상태를 paused로 설정
      const autoplayEnabled = card.dataset.autoplay === 'true'
      card.setAttribute('data-is-paused', autoplayEnabled ? 'false' : 'true')
    })
  }
  
  // 가운데 정렬 처리
  handleCenterAlignment() {
    const swiperWrapper = this.querySelector('.swiper-wrapper')
    if (!swiperWrapper || !this.slider) return
    
    const windowWidth = window.innerWidth
    
    // 모바일에서는 가운데 정렬 비활성화
    if (windowWidth < 768) {
      swiperWrapper.classList.remove('center-aligned')
      if (this.slider.params) {
        this.slider.params.loop = true
        this.slider.params.centeredSlides = true
      }
      return
    }
    
    // 현재 보이는 슬라이드 개수 계산
    let visibleSlides = 4
    if (windowWidth >= 1400) {
      visibleSlides = Number(this.dataset.breakpointXxl) || 4
    } else if (windowWidth >= 1200) {
      visibleSlides = Number(this.dataset.breakpointXl) || 4
    } else if (windowWidth >= 992) {
      visibleSlides = Number(this.dataset.breakpointLg) || 3
    } else if (windowWidth >= 768) {
      visibleSlides = Number(this.dataset.breakpointMd) || 2
    }
    
    // 슬라이드 개수가 보이는 개수보다 적거나 같으면 가운데 정렬
    if (this.totalSlides <= visibleSlides) {
      swiperWrapper.classList.add('center-aligned')
      // 루프와 centeredSlides 비활성화
      if (this.slider.params) {
        this.slider.params.loop = false
        this.slider.params.centeredSlides = false
      }
    } else {
      swiperWrapper.classList.remove('center-aligned')
      if (this.slider.params) {
        this.slider.params.loop = true
        this.slider.params.centeredSlides = false
      }
    }
  }

  // 재생/정지 토글
  togglePlayPause(video, card) {
    if (!video || !card) return
    
    if (video.paused) {
      video.play().then(() => {
        card.setAttribute('data-is-paused', 'false')
      }).catch(() => {})
    } else {
      video.pause()
      card.setAttribute('data-is-paused', 'true')
    }
  }

  // 비디오 동적 로드 및 재생
  loadAndPlayVideo(facade) {
    if (facade.classList.contains('loading') || facade.classList.contains('loaded')) {
      return // 이미 로딩 중이거나 로드 완료
    }
    
    facade.classList.add('loading')
    
    const videoWrapper = facade.closest('.lumin-shoppable-videos-video-wrapper')
    const template = videoWrapper.querySelector('.video-template')
    const card = facade.closest('.lumin-shoppable-videos-card')
    
    if (!template) {
      console.error('Video template not found')
      return
    }
    
    // 템플릿에서 비디오 엘리먼트 복제
    const videoClone = template.content.cloneNode(true)
    const video = videoClone.querySelector('video')
    
    if (!video) {
      console.error('Video element not found in template')
      return
    }
    
    // DOM에 비디오 먼저 삽입
    videoWrapper.appendChild(video)
    
    // 비디오 클릭 이벤트 (재생/일시정지)
    video.addEventListener('click', (e) => {
      e.stopPropagation()
      if (card) {
        this.togglePlayPause(video, card)
      }
    })
    
    // 비디오 에러 처리
    video.addEventListener('error', (e) => {
      console.error('Video load error:', e)
      facade.classList.remove('loading')
      alert('비디오를 로드할 수 없습니다.')
    })
    
    // UI 상태 즉시 변경 (사용자 제스처 컨텍스트에서)
    facade.classList.remove('loading')
    facade.classList.add('loaded')
    
    // 🎵 음소거 해제 및 볼륨 설정
    video.muted = false
    video.volume = 1.0  // 볼륨 최대로 설정
    if (card) {
      card.setAttribute('data-is-muted', 'false')
      card.setAttribute('data-is-paused', 'false')
    }
    
    // 즉시 재생 시도 (사용자 제스처 컨텍스트 유지)
    const playPromise = video.play()
    
    if (playPromise !== undefined) {
      playPromise.catch((err) => {
        console.warn('Unmuted autoplay failed, trying muted:', err)
        // 음소거 해제 재생 실패 시 muted로 재생 시도
        video.muted = true
        if (card) card.setAttribute('data-is-muted', 'true')
        
        video.play().catch((err2) => {
          console.error('Video play failed:', err2)
          if (card) card.setAttribute('data-is-paused', 'true')
        })
      })
    }
  }

  // 뮤트/언뮤트 토글
  toggleMute(video, card) {
    if (!video || !card) return
    
    // 다른 모든 비디오 뮤트
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(otherCard => {
      if (otherCard !== card) {
        otherCard.setAttribute('data-is-muted', 'true')
        const otherVideo = otherCard.querySelector('video')
        if (otherVideo) otherVideo.muted = true
      }
    })
    
    // 현재 비디오 토글
    if (video.muted) {
      video.muted = false
      card.setAttribute('data-is-muted', 'false')
    } else {
      video.muted = true
      card.setAttribute('data-is-muted', 'true')
    }
  }

  swiperOptions () {
    const gapDesktop = Number(this.dataset.gapDesktop || 16)
    const gapMobile = Number(this.dataset.gapMobile || 8)

    return {
      speed: Number(this.dataset.sliderSpeed) || 300,
      
      // 모바일: 1개 + 양옆 살짝 보이기
      slidesPerView: 1.15,
      centeredSlides: true,
      spaceBetween: gapMobile,
      loop: true,

      breakpoints: {
        // 태블릿
        768: {
          slidesPerView: Math.min(Number(this.dataset.breakpointMd) || 2, 4) + 0.15,
          centeredSlides: false,
          spaceBetween: gapDesktop,
          loop: this.totalSlides > (Number(this.dataset.breakpointMd) || 2)
        },
        // 노트북
        992: {
          slidesPerView: Math.min(Number(this.dataset.breakpointLg) || 3, 5) + 0.15,
          centeredSlides: false,
          spaceBetween: gapDesktop,
          loop: this.totalSlides > (Number(this.dataset.breakpointLg) || 3)
        },
        // 데스크탑
        1200: {
          slidesPerView: Math.min(Number(this.dataset.breakpointXl) || 4, 6) + 0.15,
          centeredSlides: false,
          spaceBetween: gapDesktop,
          loop: this.totalSlides > (Number(this.dataset.breakpointXl) || 4)
        },
        // 대형 화면
        1400: {
          slidesPerView: Math.min(Number(this.dataset.breakpointXxl) || 4, 6) + 0.15,
          centeredSlides: false,
          spaceBetween: gapDesktop,
          loop: this.totalSlides > (Number(this.dataset.breakpointXxl) || 4)
        }
      },
  
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: false,
      scrollbar: false,
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false
    }
  }

  onSlideChange () {
    // 슬라이드 변경 시 모든 비디오 뮤트
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(card => {
      card.setAttribute('data-is-muted', 'true')
      const video = card.querySelector('video')
      if (video) {
        video.muted = true
      }
    })
  }
}

customElements.define('lumin-shoppable-videos', KsShoppableVideos)

  } catch(e) { console.error(e); }
})();
})();
